// 9fbef606107a605d69c0edbcd8029e5d 
export const ADOBE_VENDOR_KEY = 'AMCV_9A0A1C8B5329646E0A490D4D@AdobeOrg';
export const BRANDS = {
  TCP: 'tcp',
  GYM: 'gym',
};
